import { Controller } from '@hotwired/stimulus';

/**
 * eKYC本人確認ページ離脱時の警告を表示するコントローラー
 *
 * 使用方法:
 * <div data-controller="ekyc-page">
 *   ...
 * </div>
 */
export default class extends Controller {
  connect() {
    this.boundBeforeUnload = this.handleBeforeUnload.bind(this);
    window.addEventListener('beforeunload', this.boundBeforeUnload);
  }

  disconnect() {
    window.removeEventListener('beforeunload', this.boundBeforeUnload);
  }

  handleBeforeUnload(e) {
    e.preventDefault();
    e.returnValue = '';
  }
}
